export default "__VITE_ASSET__CGC944y8__"